export const skillsData = [{
    label: "FRONT END",
      data:[

        {
          skillName: "HTML",
          percentage: "90",
        },
        {
          skillName: "CSS",
          percentage: "90",
        },
        {
          skillName: "JAVASCRIPT",
          percentage: "90",
        },
        {
          skillName: "REACT JS",
          percentage: "90",
        }
      ],
  },
  {
      label: "BACK END",
      data: [
        {
          skillName: "Java fullstack",
          percentage: "100",
        },
        {
          skillName: "NODE JS",
          percentage: "40",
        },
        {
          skillName: "EXPRESS JS",
          percentage: "40",
        },
        {
          skillName: "C",
          percentage: "60",
        },
        {
          skillName: "C#",
          percentage: "30",
        },
        {
          skillName: "PYTHON",
          percentage: "10",
        },
      ]
  },

    {
      label: "DATABASES",
      data: [
        {
          skillName: "MySQL",
          percentage: "60",
        },
        {
          skillName: "MONGODB",
          percentage: "60",
        },
        {
          skillName: "Heroku",
          percentage: "60",
        },
        {
          skillName: "netlify",
          percentage: "60",
        },
      ],
  },
];
